import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PrintService } from 'app/print/print.service';
import { SagView, SPLibrary } from '@store/models';
import { AlertService } from '../alerts/alert.service';

@Component({
    selector: 'app-skilleblade-modal-ui',
    templateUrl: './skilleblade-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkillebladeModalComponent implements OnChanges {

    form: UntypedFormGroup;
    @Input() cases: SagView[];
    @Input() splibrary: SPLibrary[];
    arbejdsarkiverAlle = false;
    stamarkiverAlle = false;
    AlleInProgress = false;

    get casesSkilleblade() {
        return this.cases.filter(c => c.locked && !c.lukket);
    }

    get stamarkiver() {
        return this.splibrary
            ? this.splibrary.filter(sp => sp.archives === 'Stamarkiv,').sort((a, b) => a.libname.localeCompare(b.libname))
            : [];
    }

    get arbejdsarkiver() {
        return this.splibrary
            ? this.splibrary.filter(sp => sp.archives === 'Arbejdsarkiv,').sort((a, b) => a.libname.localeCompare(b.libname))
            : [];
    }

    constructor(
        private fb: UntypedFormBuilder,
        private activeModal: NgbActiveModal,
        public printService: PrintService,
        private alert: AlertService
    ) {
        this.createForm();
        this.arkiverChange('stamarkiver');
        this.arkiverChange('arbejdsarkiver');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.splibrary && this.splibrary) {
            const stamarkiver = this.splibrary.filter(sp => sp.archives === 'Stamarkiv,');
            stamarkiver.map(sa => {
                (this.form.get('stamarkiver') as UntypedFormGroup)
                    .addControl(sa.id.toString(), new UntypedFormControl(false));
            });
            const arbejdsarkiver = this.splibrary.filter(sp => sp.archives === 'Arbejdsarkiv,');
            arbejdsarkiver.map(aa => {
                (this.form.get('arbejdsarkiver') as UntypedFormGroup)
                    .addControl(aa.id.toString(), new UntypedFormControl(false));
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            stamarkiver: this.fb.group({}),
            arbejdsarkiver: this.fb.group({}),
            sag: [null]
        });
    }

    arkiverChange(groupName: string) {
        const group = <UntypedFormGroup>this.form.get(groupName);
        group.valueChanges.forEach(value => {
            if (this.AlleInProgress) { return; }
            for (const k in value) {
                if (value.hasOwnProperty(k)) {
                    if (!value[k]) {
                        if (groupName === 'arbejdsarkiver') { this.arbejdsarkiverAlle = false; }
                        if (groupName === 'stamarkiver') { this.stamarkiverAlle = false; }
                        return;
                    }
                }
            }
        });
    }

    clickedAlle(groupName: string, checked: boolean) {
        if (groupName === 'arbejdsarkiver') { this.arbejdsarkiverAlle = checked; }
        if (groupName === 'stamarkiver') { this.stamarkiverAlle = checked; }
        this.AlleInProgress = true;
        const group = this.form.get(groupName) as UntypedFormGroup;
        Object.keys(group.controls).forEach(key => {
            const control = group.get(key);
            control.setValue(checked);
        });
        this.AlleInProgress = false;
    }

    clickedClose() {
        this.activeModal.dismiss();
    }

    clickedPrint() {
        const stamarkiverIds = this.getSelectedIds('stamarkiver');
        const arbejdsarkiverIds = this.getSelectedIds('arbejdsarkiver');
        const sagId = this.form.get('sag').value;
        if (arbejdsarkiverIds.length > 0 && !sagId) {
            this.alert.createAlert('Der skal vælges en sag!', 'warning');
            return;
        }
        this.printService.printSkilleblade([...stamarkiverIds, ...arbejdsarkiverIds], sagId);
    }

    getSelectedIds(groupName: string): number[] {
        const result = [];
        const group = this.form.get(groupName) as UntypedFormGroup;
        Object.keys(group.controls).forEach(key => {
            const control = group.get(key);
            if (control.value) { result.push(+key); }
        });
        return result;
    }

}
